import {
  SizeCharts_ProductSizeTable,
  SizeCharts_SizeSystem,
  SizeCharts as SizeChartsProps,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_charts.types';
import {
  DropDownProps,
  FlyoutProps,
  FONT_SIZES,
  Table,
  Text,
} from '@aboutyou/ui-components';
import {range} from '@aboutyou/utils';
import React, {FC} from 'react';
import styled from 'styled-components';
import {SizesSystemSelector} from './SizesSystemSelector';
import {useSelectedSizeSystem} from './useSelectedSizeSystem';

export const SpecificSizeChart: FC<{
  selectedOption: number;
  productSizeTable: SizeCharts_ProductSizeTable;
  sizeSystemSelector?: React.ReactNode;
  sizeSystemLayout: React.FC<FlyoutProps> | React.FC<DropDownProps>;
  setSelectedSizeSystemType: React.Dispatch<React.SetStateAction<number>>;
}> = ({
  selectedOption,
  productSizeTable,
  sizeSystemLayout,
  setSelectedSizeSystemType,
}) => {
  const selectedSizeSystem = useSelectedSizeSystem(
    selectedOption,
    productSizeTable.sizeSystems,
  );

  return (
    <>
      <Text weight="w500" size="px16" data-testid="specificSizeChart-title">
        {productSizeTable.headline}
      </Text>
      <StyledTable
        headerContent={[
          [
            <>
              <Text size="px12" weight="w500">
                {productSizeTable.firstColumnHeader}
                <sup>*</sup>
              </Text>
            </>,
            <>
              <SizesSystemSelector
                selectedOption={selectedOption}
                options={productSizeTable.sizeSystems}
                onClick={setSelectedSizeSystemType}
                LayoutComponent={sizeSystemLayout}
                dataTestId="specificSizeChartSelector"
                openedStateKey="size-chart-selector-1"
              />
            </>,
          ],
        ]}
        bodyContent={normalizeSizesSystemsBody(
          productSizeTable,
          selectedSizeSystem,
        )}
        dataTestId="specificSizeChart-table"
      />
      <NoteText
        color="Grey1"
        size="px12"
        data-testid="specificSizeChart-noteText"
      >
        <sup>*</sup>
        {productSizeTable.disclaimerText}
      </NoteText>
    </>
  );
};

const normalizeSizesSystemsBody = (
  productSizeTable: SizeChartsProps['productSizeTable'],
  selectedSizeSystem: SizeCharts_SizeSystem | undefined,
) => {
  if (!selectedSizeSystem) return [];

  const sizesArrayLength = selectedSizeSystem?.sizeLabels.length;
  return range(0, sizesArrayLength).map(index => {
    return [
      productSizeTable.vendorSizes[index]?.label,
      selectedSizeSystem?.sizeLabels[index],
    ];
  });
};

const StyledTable = styled(Table)`
  margin: 10px 0;
  font-size: ${FONT_SIZES.px12};
`;

const NoteText = styled(Text)`
  line-height: 1.5;
`;
